import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/api";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import Categories from "@/pages/admin/Categories";
import SubCategories from "@/pages/admin/SubCategories";
import Menus from "@/pages/admin/Menus";
import Transactions from "@/pages/admin/Transactions";
import Report from "@/pages/admin/Report";
import Accounts from "@/pages/admin/Accounts";
import AppSettings from "@/pages/admin/AppSettings";
import Kasir from "@/pages/Kasir";
import Waiter from "@/pages/Waiter";
import WaiterOrder from "@/pages/WaiterOrder";
import Dapur from "@/pages/Dapur";
import Checker from "@/pages/Checker";
import Profile from "@/pages/Profile";

function Guard({ roles, children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="grid min-h-screen place-items-center text-sm text-zinc-500">Memuat...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && user.role !== "admin" && !roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? ROLE_HOME[user.role] : "/login"} replace />;
}

const g = (roles, el) => <Guard roles={roles}>{el}</Guard>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route element={<Guard><AppShell /></Guard>}>
            <Route path="/admin" element={g(["admin"], <AdminDashboard />)} />
            <Route path="/admin/kategori" element={g(["admin"], <Categories />)} />
            <Route path="/admin/sub-kategori" element={g(["admin"], <SubCategories />)} />
            <Route path="/admin/menu" element={g(["admin"], <Menus />)} />
            <Route path="/admin/transaksi-berjalan" element={g(["admin"], <Transactions mode="active" />)} />
            <Route path="/admin/riwayat-transaksi" element={g(["admin"], <Transactions mode="paid" />)} />
            <Route path="/admin/laporan" element={g(["admin"], <Report />)} />
            <Route path="/admin/akun" element={g(["admin"], <Accounts />)} />
            <Route path="/admin/aplikasi" element={g(["admin"], <AppSettings />)} />
            <Route path="/kasir" element={g(["kasir"], <Kasir />)} />
            <Route path="/kasir/riwayat" element={g(["kasir"], <Transactions mode="paid" />)} />
            <Route path="/kasir/laporan" element={g(["kasir"], <Report />)} />
            <Route path="/waiter" element={g(["waiter"], <Waiter />)} />
            <Route path="/waiter/bill/:id" element={g(["waiter"], <WaiterOrder />)} />
            <Route path="/dapur" element={g(["dapur"], <Dapur />)} />
            <Route path="/checker" element={g(["checker"], <Checker />)} />
            <Route path="/akun" element={<Profile />} />
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}

export default App;
